// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2i_dV","productName":"Table_productName__29uMI"};